import { motion } from "framer-motion";
import { EVENTS } from "@/lib/wedding";

/**
 * Itinerary
 * -----------------------------------------------------------
 * Ceremony cards driven by EVENTS in wedding.js.
 */
export default function Itinerary() {
  return (
    <section id="itinerary" className="relative edge py-24 bg-ivory text-center">
      <div className="overline text-rani mb-5">Shubh Muhurat</div>
      <h2 className="font-display text-4xl sm:text-6xl text-rani">Ceremonies</h2>
      <div
        className="mx-auto mt-6 mb-14 h-px w-40"
        style={{ background: "linear-gradient(90deg, rgba(201,169,97,0) 0%, rgba(201,169,97,0.7) 50%, rgba(201,169,97,0) 100%)" }}
      />

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
        {EVENTS.map((e, i) => (
          <motion.article
            key={e.key}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="border border-gold bg-bone rounded-2xl overflow-hidden flex flex-col"
          >
            {/* Thin gold band in place of a photo */}
            <div className="h-1.5" style={{ background: "linear-gradient(90deg, #C9A961 0%, #E8CC7E 50%, #C9A961 100%)" }} />
            <div className="p-6 flex flex-col flex-1">
              <h3 className="font-display text-2xl text-rani">{e.name}</h3>
              <div className="mt-2 text-[11px] uppercase tracking-chip text-gold-deep">
                {e.date} · {e.time}
              </div>
              {e.blurb && <p className="mt-3 font-body text-ink/80 leading-relaxed text-sm">{e.blurb}</p>}
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
